<template>
  <el-avatar :class="style.avatar" @error="errorHandler">
    <img
      :src="isDark === 'light' ? defaultImg : defaultImgDark"
    >
  </el-avatar>
</template>

<script lang="ts" setup>
const errorHandler = () => true;
import { useCommonStore } from '@/store/common';
import defaultImg from './logo-light.svg';
import defaultImgDark from './logo-dark.svg';
const store = useCommonStore();
const isDark = computed(() => store.isDark);
</script>

<style lang="scss" module="style">
.avatar {
  --el-avatar-bg-color: transparent;
}
</style>
